import { AxiosError } from "axios"

export const ONE_MINUTE = 60_000
export const THREE_MINUTES = 180_000
export const FIVE_MINUTES = 300_000
export const ONE_DAY = 86_400_000

export interface CustomUseMutationOptions {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSuccess?: (data?: any) => void
  onError?: (error: AxiosError) => void
  onSettled?: () => void
}
